import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import RecoverySuccessComponent from './recovery-success.component';

let RecoverySuccessModule = angular
  .module('RecoverySuccess', [
    uiRouter
  ])
  .component('recoverySuccess', RecoverySuccessComponent)
  .config(($stateProvider) => {
    "ngInject";
    $stateProvider.state('recoverySuccess', {
      url: '/recovery-success',
      views: {
        'menu': "",
        'content': {
          component: 'recoverySuccess'
        }
      }
    })
  })
  .name;

export default RecoverySuccessModule;



// WEBPACK FOOTER //
// ./src/app/pages/recovery-success/recovery-success.module.js